// Les événements écrits par thèmes. Chaque paquet a ses événements (x.ts) et ses textes (x.fr.ts).
import type { EventDef } from '../events';
import { EVENTS as argent } from './argent';
import { EVENTS as consommation } from './consommation';
import { EVENTS as etudes } from './etudes';
import { EVENTS as logement } from './logement';
import { EVENTS as proches } from './proches';
import { EVENTS as quotidien } from './quotidien';
import { EVENTS as sante } from './sante';
import { EVENTS as transport } from './transport';
import { EVENTS as travail } from './travail';

export const PACK_EVENTS: EventDef[] = [
  ...quotidien,
  ...transport,
  ...travail,
  ...proches,
  ...consommation,
  ...argent,
  ...sante,
  ...etudes,
  ...logement,
];
